import React from 'react';
import PropTypes from 'prop-types';
import ImageQuestion from '../imageQuestion/ImageQuestion';

export default function Question05(props) {
  return (
    <ImageQuestion
      articleClassModifier=''
      imageType='WIDE'
      imageGridClassModifier='l-choice-grid--wide-two'
      agreementText
      media={false}
      {...props}
    />
  );
}

Question05.propTypes = {
  question: PropTypes.object.isRequired,
  communityAnswer: PropTypes.array.isRequired,
  onSubmitQuestion: PropTypes.func.isRequired,
  isResult: PropTypes.bool.isRequired,
  showCoin: PropTypes.bool.isRequired,
  questionButtonClicked: PropTypes.func.isRequired,
};
